export function getEditFormConfig() {
	return {
		DESC: [
			{
				el: "el-input",
				label: "名称",
				name: "name",
				attrs: {
					placeholder: "请输入名称",
				},
			},
			{
				el: "rich-text",
				label: "标题",
				name: "title",
				attrs: {
					keyWord: "title",
					params: "",
				},
				show: {
					key: "innerVisible",
				},
			},
			{
				el: "rich-text",
				label: "维度解析",
				name: "descr",
				attrs: {
					keyWord: "descr",
					params: "",
				},
				show: {
					key: "innerVisible",
				},
			},
		],
	};
}
